import ApiEndpoints from '@/config/ApiEndpoints';
import ApiService from '@/services/ApiService';

export default class UpdateUser {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * UpdateUser constructor.
     *
     * @param {ApiService|null} apiService
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle updating the authenticated user's data.
     *
     * @param {*} payload
     *
     * @returns {Promise}
     */
    handle(payload) {
        let apiUrl = ApiEndpoints['users.update'];

        return this.apiService
            .patch(apiUrl, {
                'first_name': payload.firstName,
                'last_name': payload.lastName,
                'email': payload.email,
                'telephone': payload.telephone,
                'opt_in': payload.optIn,
                'weekly_email': payload.weeklyEmail,
                'password': payload.password || null,
            });
    }
}
